export default "__VITE_ASSET__DhZ0aXXp__"